import { SignIn, SignUp, useAuth } from "@clerk/react";
import { Navigate, useSearchParams } from "react-router";
import { Initialize } from "@/pages/initialize/initialize";
import { getAuthRedirect } from "@/lib/auth/redirect";

export default function AuthPage({ signUp = false }: { signUp?: boolean }) {
    const { isLoaded, isSignedIn } = useAuth();
    const [params] = useSearchParams();
    const target = getAuthRedirect(params.get("redirect_url"));
    const query = `?redirect_url=${encodeURIComponent(target)}`;

    if (!isLoaded) return <Initialize />;
    if (isSignedIn) return <Navigate to={target} replace />;

    return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-8 bg-background p-4">
            <img src="/img/logo.svg" alt="Exibra CMS" className="h-12" />
            {signUp ? (
                <SignUp
                    routing="path"
                    path="/sign-up"
                    signInUrl={`/auth${query}`}
                    forceRedirectUrl={target}
                />
            ) : (
                <SignIn
                    routing="path"
                    path="/auth"
                    signUpUrl={`/sign-up${query}`}
                    forceRedirectUrl={target}
                    signUpForceRedirectUrl={target}
                />
            )}
        </div>
    );
}
